/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from "@/http/requests/auth/jwt/index.js";
import { getUserDetails } from "@/api/Auth";
import { setUserDetails, setPermissions } from "@/utils/auth";

import router from "@/router";
import CookieKeys from "@/model/constants/cookieKeys";

export default {
  // JWT
  loginJWT({ commit }, payload) {
    let promiseResult = new Promise((resolve) => {
      // If there's user data in response
      localStorage.setItem(CookieKeys.AUTH_KEY, payload);

      // Set accessToken Cookie
      commit("SET_TOKEN_COOKİE", payload, {
        root: true,
      });

      // Set bearer token in axios
      commit("SET_BEARER", payload);

      resolve(payload);
    });

    promiseResult.then(() => {
      //Get UserDetails
      getUserDetails()
        .then((userDetailResponse) => {
          // Set UserDetails Cookie
          setUserDetails(userDetailResponse.data.user);
          // Set Permissions Cookie
          setPermissions(userDetailResponse.data.permissions);

          //Set UserDetails Local
          commit("UPDATE_USER_INFO", userDetailResponse.data.user, {
            root: true,
          });
          //dispatch("setNeedStockTransfer", null, { root: true })
          console.log(localStorage.getItem("isBis"));
          if (localStorage.getItem("isBis") === "true") {
            router.push("/pages/cis");
          } else {
            const permissions = userDetailResponse.data.permissions;
            if (permissions.some((x) => x.name == "kiosk_access")) {
              router.push("/pages/kiosk");
            } else if (permissions.some((x) => x.name == "admin_access")) {
              router.push("/");
            } else {
              router.push("/pages/selfservice-select");
            }
          }
        })
        .catch(() => {});
    });
  },
  registerUserJWT({ commit }, payload) {
    const { displayName, email, password, confirmPassword } =
      payload.userDetails;

    return new Promise((resolve, reject) => {
      // Check confirm password
      if (password !== confirmPassword) {
        reject({
          message: "Password doesn't match. Please try again.",
        });
      }

      jwt
        .registerUser(displayName, email, password)
        .then((response) => {
          // Redirect User
          router.push(router.currentRoute.query.to || "/");

          // Update data in localStorage
          localStorage.setItem("accessToken", response.data.accessToken);
          commit("UPDATE_USER_INFO", response.data.userData, {
            root: true,
          });

          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchAccessToken() {
    return new Promise((resolve) => {
      jwt.refreshToken().then((response) => {
        resolve(response);
      });
    });
  },
};
